"use client";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function CustomerReviews() {
	const t = useTranslations();

	const reviews = [
		{
			id: 1,
			name: "Christopher Davis",
			content: t("home.r1"),
			img: "/image/home/review/1.webp",
			rating: 5,
		},
		{
			id: 2,
			name: "Isabella Garcia",
			content: t("home.r2"),
			img: "/image/home/review/3.webp",
			rating: 5,
		},
		{
			id: 3,
			name: "Daniel Rodriguez",
			content: t("home.r3"),
			img: "/image/home/review/2.webp",
			rating: 5,
		},
		{
			id: 4,
			name: "Ava Martinez",
			content: t("home.r4"),
			img: "/image/home/review/4.webp",
			rating: 5,
		},
		{
			id: 5,
			name: "Matthew Taylor",
			content: t("home.r5"),
			img: "/image/home/review/5.png",
			rating: 5,
		},
	];

	return (
		<section className="bg-black py-16 text-white" aria-labelledby="reviews-section-title">
			<div className="container mx-auto px-4">
				<header className="flex flex-col items-center gap-2">
					<h2
						id="reviews-section-title"
						className="font-queens group relative mb-4 text-center text-[32px] font-medium md:text-[42px] lg:text-[52px]"
					>
						{t("home.rt1")}
						<span className="absolute bottom-0 left-0 h-0.5 w-0 bg-white transition-all duration-300 group-hover:w-full"></span>
					</h2>
				</header>

				<div className="relative w-full overflow-hidden">
					<Swiper
						modules={[Autoplay]}
						spaceBetween={20}
						slidesPerView={1.2}
						centeredSlides={true}
						loop={true}
						speed={500}
						autoplay={{
							delay: 3000,
							disableOnInteraction: false,
							reverseDirection: false,
						}}
						breakpoints={{
							640: {
								slidesPerView: 1.6,
								spaceBetween: 20,
							},
							768: {
								slidesPerView: 2.2,
								spaceBetween: 20,
							},
							1024: {
								slidesPerView: 2.6,
								spaceBetween: 20,
							},
						}}
						className="w-full"
						aria-label="Customer Reviews Carousel"
					>
						{[...reviews, ...reviews].map((review, index) => (
							<SwiperSlide key={`${review.id}-${index}`}>
								<article className="mx-2 h-full rounded-sm border border-white bg-black">
									<div className="flex h-[400px] max-xl:flex-col">
										<div className="hidden max-xl:block">
											<img
												src={review.img}
												alt={`${review.name}'s photo`}
												className="h-[150px] w-full object-cover"
											/>
										</div>
										<div className="flex w-1/2 flex-col justify-between p-6 max-xl:w-full max-xl:p-3">
											<blockquote className="mb-3 text-[12px] max-lg:leading-[14px] max-md:text-[12px] max-md:leading-[14px]">
												{review.content}
											</blockquote>
											<footer>
												<cite className="mb-2 font-bold not-italic">{review.name}</cite>
												<div className="flex max-xl:hidden" aria-label={`Rating: ${review.rating} stars`}>
													{[...Array(review.rating)].map((_, i) => (
														<span key={i} className="mr-1 text-main" aria-hidden="true">
															★
														</span>
													))}
												</div>
											</footer>
										</div>
										<div className="relative w-1/2 max-xl:hidden">
											<Image src={review.img} alt={`${review.name}'s photo`} fill className="object-cover" />
										</div>
									</div>
								</article>
							</SwiperSlide>
						))}
					</Swiper>
				</div>

				<footer className="mt-10 text-center">
					<Link
						href="/about-us"
						className="group relative inline-block overflow-hidden rounded-xl bg-white px-16 py-4 font-medium text-black transition-all duration-300 hover:!text-white"
						aria-label="Learn more about us"
					>
						<span className="relative z-10">{t("home.rb")}</span>
						<span
							className="absolute left-0 top-0 h-full w-0 bg-main opacity-0 transition-all duration-500 ease-in-out group-hover:w-full group-hover:opacity-100"
							aria-hidden="true"
						></span>
					</Link>
				</footer>
			</div>
		</section>
	);
}
